





































































































import { Vue, Component, Prop } from 'vue-property-decorator';

import eventBus from '@/utils/eventBus';

import CloseModalIcon from '@/components/icons/CloseModal.vue';
import InfoIcon from '@/components/icons/Info.vue';
import Trigger from '@/componentsV2/molecules/Trigger/Trigger.vue';
import Picture from '@/components/atoms/Picture/Picture.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';

import PayoutStatus from '@/componentsV2/molecules/PayoutStatus/PayoutStatus.vue';

import { IPayouts } from '@/models/performance';
import PaginationUtils, { IPagination } from '@/utils/PaginationUtils';
import SellCoinsService from '@/api/SellCoinsService';
import DateUtils from '@/utils/DateUtils';
import segmentIo from '@/utils/segment.io';

@Component({
  components: {
    CloseModalIcon,
    PayoutStatus,
    Picture,
    FilledButton,
    InfoIcon,
    Trigger
  }
})
export default class PayoutsHistory extends Vue {
  @Prop() onConfirm!: any;

  sellCoinsService = new SellCoinsService();

  pagination: IPagination = PaginationUtils.defaultPagination();
  payoutHistory: IPayouts[] = [];
  months: string[] = [];

  handleClose() {
    eventBus.$emit('closeModal');
  }

  handleConfirm() {
    this.handleClose();
    this.onConfirm();
  }

  get tPrefix() {
    return 'sellCoins.overview.cards.payout.modal';
  }

  async loadPayoutHistory({ clearList = false } = {}) {
    if (clearList) {
      this.pagination = PaginationUtils.defaultPagination();
    }

    if (!this.pagination.mustCallApi) return;

    let endpointPath = '/admin/business-wallet/payout-history';

    if (this.pagination.next) {
      endpointPath = this.pagination.next;
    }

    this.$showLoaderWithLocker();

    const response = await this.sellCoinsService.getPayoutHistory(endpointPath);

    this.$hideLoader();

    if (response.status !== 200) return;

    const { items, links } = response.data;

    Object.assign(this.pagination, {
      next: links.next,
      mustCallApi: !!links.next
    });

    if (clearList) {
      this.payoutHistory = this.formattedPayoutHistory(items);

      return;
    }

    this.payoutHistory = [
      ...this.payoutHistory,
      ...this.formattedPayoutHistory(items)
    ];
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 0);

    PaginationUtils.makeNewRequest(
      {
        triggerClass: '.infinite-trigger-payout',
        hasPagination: !!this.pagination.next
      },
      this.loadPayoutHistory
    );
  }

  formattedPayoutHistory(payoutHistory: IPayouts[]) {
    return payoutHistory.map((item, index) => {
      let header;
      const period = DateUtils.formattedDate({
        date: item.payout.createdAt,
        format: 'MMMM,YYYY',
        applyTimezone: true
      });

      if (!this.months.includes(period)) {
        this.months.push(period);

        const [month, year] = period.split(',');

        header = {
          month,
          year
        };
      }

      return {
        ...item,
        header,
        formatted: {
          ...item.formatted,
          createdAt: DateUtils.formattedDate({
            date: item.payout.createdAt,
            applyTimezone: true
          })
        }
      };
    });
  }

  created() {
    segmentIo.modal('Payout History');
  }
}
